import { useNavigate } from "react-router-dom";

import axios from 'axios';
import useEndpoints from "../api/useEndpoints";
import errorHandler from "../api/errorHandler";
import { useState, useEffect } from "react";
import Toast from './toast'
import paths from './../config/paths.json'
import { FaArrowLeft } from 'react-icons/fa';
import Storages from "../helper/storages";
import initUserInfo from "../api/initUserInfo";
import LoginHeader from "./loginHeader";
import { fa2En } from '../helper/InputHelper'
import { useMediaQuery } from 'react-responsive'


export default function LoginVerify() {
  const endpoints = useEndpoints();
  const navigate = useNavigate();
  const [state, setState] = useState()
  const isMobile = useMediaQuery({ query: `(max-width: 767px)` });
  var bg_lg = require(`../assets/images/${process.env.REACT_APP_ENV}/bg-lg.jpg`)
  var bg_sm = require(`../assets/images/${process.env.REACT_APP_ENV}/bg-sm.jpg`)

  //بازگشت به صفحه قبل
  var changeNumber = () => {
    navigate(-1);
  }

  //درخواست تایید هویت
  var onVerifyPress = () => {
    axios.get(endpoints.verify, {
      params:
      {
        username: fa2En(Storages.getUserName()),
        password: Storages.getUserPass(),
        verifyCode: state.verifyCode
      }
    }, {
      headers: { 'x-auth-token': Storages.getUserToken() },
    }).then((res) => {

      initUserInfo(res.data.result)
      navigate(paths.dashboard)

    }).catch((e) => {
      console.log(e)
      errorHandler(e)
    })
  }

  //دریافت اطلاعات از ورودی ها
  let onInputChange = (e) => {
    try {
      let name = e.target.name;
      let value = e.target.value;
      setState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } catch (e) {
      console.log(e);
    }
  };

  // تابع محاسبه زمان بافی مانده
  function getRemainigTime() {
    return Math.round((Storages.getAllowReqAfterSec() - new Date().getTime()) / 1000)
  }
  // زمان باقی مانده برای ارسال مجدد درخواست
  var [remainingTime, setRemainingTime] = useState(getRemainigTime())
  // ای دی شمارنده برای غیر فعال کردن اون در بخش های دیگر
  var [timerId, setTimerId] = useState();


  //مربوط به نمایش شمارنده زمان 
  useEffect(() => {
    var timer;
    if (remainingTime > 0)
      timer = setInterval(() => {
        console.log(Storages.getAllowReqAfterSec(), new Date().getTime())
        setRemainingTime(getRemainigTime());
      }, 1000);
    setTimerId(timer)
    return () => {
      clearInterval(timer);
    };
  }, []);

  //بعد از پایان زمان ارسال مجدد فعال میشد
  useEffect(() => {
    if (remainingTime <= 0) {
      clearInterval(timerId);
    }
  }, [remainingTime])

  return (

    <div className="overflow-hidden">

      <div className=" position-absolute d-flex col-12  justify-content-center align-items-center  p-3">


        <div className="w-100 vh-100 position-absolute bg-dark align-items-center overflow-hidden  justify-content-center d-flex ">
          {
            isMobile ?
              <img className="center-cropped " src={bg_sm} />
              :
              <img className="  center-cropped " src={bg_lg} />


          }

        </div>

        <div className="d-flex me-auto"
          style={{ cursor: 'pointer' }}
          onClick={changeNumber}>
          <p className="p-0 m-0  iranSansBold text-light ms-2" >تغییر شماره</p>
          <FaArrowLeft className="bg-dark p-0 m-0 text-light " size={27} />
        </div>

      </div>



      <div className="d-flex justify-content-center align-items-center bg-dark vh-100 overflow-auto" style={{ top: 0, right: 0, bottom: 0, left: 0 }} >

        <div className="d-flex flex-column justify-content-center align-items-center  ">


          <LoginHeader />
          <div className="card  p-3 col-12 ">
            <h5 className="justify-content-center align-items-center d-flex iranSansBold">صفحه احراز هویت</h5>

            <div className="form-group pt-4">
              <label htmlFor="verifyCode" className="pb-1">کد تایید به شماره<span dir="ltr" className="ps-1">{Storages.getHashedPhoneNumber()} </span> ارسال شد </label>
              <input type="text" name="verifyCode" className="form-control" placeholder="کد تایید" onChange={onInputChange} />
            </div>

            {
              remainingTime <= 0 ?
                <label htmlFor="username" className="pb-1 mt-2">کد را دریافت نکرید؟ <a className="text-primary" onClick={() => {
                  navigate(-1)
                }}>ارسال مجدد</a> </label>

                :
                <label htmlFor="username" className="pb-1 mt-2">ارسال مجدد کد تایید پس از : {remainingTime} ثانیه</label>

            }

            <button onClick={onVerifyPress} to="/" className="btn btn-primary iranSansBold mt-2">ورود</button>
          </div>
          <small className="form-text text-muted">1401 © توسعه و اجرا توسط شرکت <a href="http://efspco.ir" target="_blank">ابتکار فناوران سهند پویا</a> </small>
        </div>

      </div>

    </div>


  );

}